import React, { useEffect, useMemo, useParams, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Card } from "@mui/material";
import TableMaestros from "verticales/TableMaestros.tsx";

function TableActiveDirectory(props: any) {
  // declaracion de variables de la pantalla
  // console.log("Tabla Directorio", props);
  const [data, setData] = useState([]);
  const columns = useMemo(
    () => [
      { header: "username", accessorKey: "username" },
      { header: "groupname", accessorKey: "groupname" },
    ],
    []
  );

  return (
    <Grid item xs={12} md={12} lg={12}>
      <MDBox m={1}>
        <TableMaestros arrayColumns={columns} data={props.data} noActionsEdit={true} height={650} />
      </MDBox>
    </Grid>
  );
}

export default TableActiveDirectory;
